import { Type } from '@angular/core';

import { PolycomVvx250Component } from '../devices/polycom-devices/polycom-vvx-250/polycom-vvx-250.component';
import { PolycomVvx350Component } from '../devices/polycom-devices/polycom-vvx-350/polycom-vvx-350.component';
import { PolycomVvx450Component } from '../devices/polycom-devices/polycom-vvx-450/polycom-vvx-450.component';
import { YealinkT41Component } from '../devices/yealink-devices/yealink-t41/yealink-t41.component';
import { YealinkT43Component } from '../devices/yealink-devices/yealink-t43/yealink-t43.component';
import { YealinkT44Component } from '../devices/yealink-devices/yealink-t44/yealink-t44.component';
import { YealinkT46Component } from '../devices/yealink-devices/yealink-t46/yealink-t46.component';
import { YealinkT53Component } from '../devices/yealink-devices/yealink-t53/yealink-t53.component';
import { YealinkT54Component } from '../devices/yealink-devices/yealink-t54/yealink-t54.component';
import { YealinkT73Component } from '../devices/yealink-devices/yealink-t73/yealink-t73.component';
import { YealinkT74Component } from '../devices/yealink-devices/yealink-t74/yealink-t74.component';
import { YealinkT77Component } from '../devices/yealink-devices/yealink-t77/yealink-t77.component';
import { YealinkT85Component } from '../devices/yealink-devices/yealink-t85/yealink-t85.component';
import { YealinkT87Component } from '../devices/yealink-devices/yealink-t87/yealink-t87.component';
import { YealinkT88Component } from '../devices/yealink-devices/yealink-t88/yealink-t88.component';
import { PolycomPhoneModelCode } from '../enums/polycom-phone-model.enum';
import { YealinkPhoneModelCode } from '../enums/yealink-phone-model.enum';

export const POLYCOM_PHONE_COMPONENTS: Record<PolycomPhoneModelCode, Type<any>> = {
  VVX250: PolycomVvx250Component,
  VVX350: PolycomVvx350Component,
  VVX450: PolycomVvx450Component,
};

export const YEALINK_PHONE_COMPONENTS: Record<YealinkPhoneModelCode, Type<any>> = {
  T41: YealinkT41Component,
  T43: YealinkT43Component,
  T44: YealinkT44Component,
  T46: YealinkT46Component,
  T53: YealinkT53Component,
  T54: YealinkT54Component,
  T73: YealinkT73Component,
  T74: YealinkT74Component,
  T77: YealinkT77Component,
  T85: YealinkT85Component,
  T87: YealinkT87Component,
  T88: YealinkT88Component,
};
